import { useProfilForm } from "../hooks/use-profil-form";
import { ProfilFormFields } from "./profil-form-fields";

interface CreateProfilFormProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export function CreateProfilForm({ onCancel, onSuccess }: CreateProfilFormProps) {
  const {
    formData,
    error,
    droitOptions,
    isEditing,
    isLoading,
    isLoadingDroits,
    isPending,
    handleInputChange,
    handleSelectChange,
    handleCheckboxChange,
    handleSubmit,
  } = useProfilForm({ onSuccess });

  if (isLoading) {
    return <div className="flex justify-center p-4">Chargement des données...</div>;
  }

  return (
    <ProfilFormFields
      formData={formData}
      error={error}
      droitOptions={droitOptions}
      isEditing={isEditing}
      isLoadingDroits={isLoadingDroits}
      isPending={isPending}
      onCancel={onCancel}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      handleCheckboxChange={handleCheckboxChange}
      handleSubmit={handleSubmit}
    />
  );
}
